<template>
	<div>
		<div class="branchinfo">
			<el-divider></el-divider>
			<div style="margin: 20px 40px 30px 20px;">
				<el-form size="mini" :model="modifyInfo"
					:label-width="(LanguageId == 1 || LanguageId == 2) ? '97px' : '310px'">
					<el-form-item :label="$t('vehicle.ManufactureNo') + '：'">
						<el-input v-model="modifyInfo.manufactureId" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" label="VIN：">
						<el-input v-model="modifyInfo.vin" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('vehicle.DeviceNo') + '：'">
						<el-input v-model="modifyInfo.deviceNo" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('vehicle.VehicleModel') + '：'">
						<el-input v-model="modifyInfo.vehicleModel" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.modellevel') + '：'"
						prop="name">
						<el-input v-model="modifyInfo.modellevel"
							:placeholder="$t('vehicleInfo.inputmodellevel')"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('failure.carNo') + '：'">
						<el-input v-model="modifyInfo.carno"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('vehicleInfo.vehicleselfNo') + '：'" prop="name">
						<el-input v-model="modifyInfo.vehicleselfNo"
							:placeholder="$t('vehicleInfo.inputvehicleselfNo')"></el-input>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicle.VelColor') + '：'">
						<el-select v-model="modifyInfo.vehicleColor" :placeholder="$t('vehicleInfo.selectVelColor')">
							<el-option v-for="(val, key) in vehicleColorList" :key="val.index" :label="val.label"
								:value="val.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.province') + '：'">
						<el-select v-model="modifyInfo.province" :placeholder="$t('vehicleInfo.inputprovince')"
							@change="seletekeyprovince(modifyInfo.province)">
							<el-option v-for="(val, key) in provicedata" :key="val.index" :label="val.label"
								:value="val.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.industry') + '：'">
						<el-select v-model="modifyInfo.industry" :placeholder="$t('vehicleInfo.inputindustry')">
							<el-option v-for="(val, key) in industryList" :key="val.index" :label="val.label"
								:value="val.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('vehicleInfo.buydate') + '：'">
						<el-col :span="11">
							<el-date-picker type="date" :placeholder="$t('龙翼简报.选择日期')" v-model="modifyInfo.buydate"
								style="width: 100%;"></el-date-picker>
						</el-col>
					</el-form-item>

					<el-form-item v-if="false" style="margin-top: 10px;"
						:label="$t('vehicleInfo.vehicleownerinfo') + '：'">
						<el-input v-model="modifyInfo.vehicleownerinfo"
							:placeholder="$t('vehicleInfo.inputvehicleownerinfo')"></el-input>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;"
						:label="$t('vehicleInfo.roadTransCerNo') + '：'">
						<el-input v-model="modifyInfo.roadTransCerNo"
							:placeholder="$t('vehicleInfo.inputroadTransCerNo')"></el-input>
					</el-form-item>

					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.businessArea') + '：'">
						<el-select v-model="modifyInfo.businessArea"
							:placeholder="$t('vehicleInfo.selectbusinessArea')">
							<el-option v-for="(val, key) in businessAreaList" :key="val.index" :label="val.label"
								:value="val.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('vehicleInfo.operationalstatus') + '：'">
						<el-select v-model="modifyInfo.runState"
							:placeholder="$t('vehicleInfo.selectoperationalstatus')">
							<el-option v-for="(val, key) in operationalstatusList" :key="val.index" :label="val.label"
								:value="val.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;"
						:label="$t('vehicleInfo.electricityprice') + '：'">
						<el-input v-model="modifyInfo.electricityprice"
							:placeholder="$t('vehicleInfo.inputelectricityprice')"></el-input>
					</el-form-item>

					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.city') + '：'">
						<el-select v-model="modifyInfo.city" :placeholder="$t('vehicleInfo.selectCity')">
							<el-option v-for="(val, key) in cityList" :key="val.index" :label="val.label"
								:value="val.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicle.DeviceType') + '：'">
						<!-- <el-select v-model="modifyInfo.deviceType" placeholder="终端型号"> -->
						<!-- <el-option v-for="(val, key) in deviceTypeList" :key="val" :label="val"
							:value="val"></el-option>
					</el-select> -->
						<el-input v-model="modifyInfo.deviceType" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.usedate') + '：'">
						<el-col :span="11">
							<el-date-picker type="date" :placeholder="$t('vehicleInfo.selectusedate')"
								v-model="modifyInfo.usedate" style="width: 100%;"></el-date-picker>
						</el-col>
					</el-form-item>
					<el-form-item style="margin-top: 10px;" :label="$t('vehicleInfo.defaultDriver')+'：' "  class="driver">
					<el-select filterable v-model="modifyInfo.driver" :placeholder="$t('vehicleInfo.defaultDriver')" >
						<el-option v-for="(val, key) in driverdata" :key="val.index" :label="val.label"
							:value="val.value"></el-option>
					</el-select>
					<!-- <button style="border: 1px solid #A2B1CB;margin-left: 6px;
border-radius: 1px;height: 28px;width: 28px;" class="iconfont icon-icon_operat_increa
" @click="dialognewadd"></button> -->

				</el-form-item>


					<el-form-item v-if="false" style="margin-top: 10px;"
						:label="$t('vehicleInfo.businesslicenseNo') + '：'">
						<el-input v-model="modifyInfo.businesslicenseNo"
							:placeholder="$t('vehicleInfo.inputbusinesslicenseNo')"></el-input>
					</el-form-item>

					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.linetype') + '：'">
						<el-select v-model="modifyInfo.linetype" :placeholder="$t('vehicleInfo.selectlinetype')">
							<el-option v-for="(val, key) in linetypeList" :key="val.index" :label="val.label"
								:value="val.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.oilprice') + '：'">
						<el-input v-model="modifyInfo.oilprice"
							:placeholder="$t('vehicleInfo.inputoilprice')"></el-input>
					</el-form-item>
					<el-form-item v-if="false" style="margin-top: 10px;" :label="$t('vehicleInfo.gasprice') + '：'">
						<el-input v-model="modifyInfo.gasprice"
							:placeholder="$t('vehicleInfo.inputgasprice')"></el-input>
					</el-form-item>

				</el-form>


			</div>
		</div>
		<div style=" text-align: right;margin-right: 15px;">
			<el-button size="small " @click="cancel">{{ $t('public.cancel') }}</el-button>
			<el-button size="small " type="primary" @click="save">{{ $t('public.save') }}</el-button>
		</div>
	</div>
</template>

<script>
	import language from '@/utils/getLanguageId';
	export default {
		props: {
			driverdata: {
				type: Array,
				default: []
			},
			provicedata: {
				type: Array,
				default: []
			},
			modifyInfo: {
				type: Object,
				default: {}
			}

		},
		data() {
			return {
				LanguageId: 1,
				reset: false,
				newdriver: true,
				formLabelWidth: '272px',
				linetypeList: [{
						label: this.$t('vehicleInfo.other'),
						value: "1"
					},
					{
						label: this.$t('vehicleInfo.serviceline1'),
						value: "2"
					},
					{
						label: this.$t('vehicleInfo.serviceline2'),
						value: "3"
					},
					{
						label: this.$t('vehicleInfo.serviceline3'),
						value: "4"
					}, {
						label: this.$t('vehicleInfo.serviceline4'),
						value: "5"
					}
				],
				driverList: this.driverdata,
				proviceList: this.provicedata,
				modifyInfobj: this.modifyInfo,
				cityList: [],
				deviceTypeList: [],
				// pcaaData: pcaa,

				vehicleColorList: [{
						label: this.$t('vehicleInfo.blue'),
						value: 1
					},
					{
						label: this.$t('vehicleInfo.yellow'),
						value: 2
					},
					{
						label: this.$t('vehicleInfo.white'),
						value: 3
					},
					{
						label: this.$t('vehicleInfo.black'),
						value: 4
					},
					{
						label: this.$t('vehicleInfo.green'),
						value: 5
					},
					{
						label: this.$t('vehicleInfo.other'),
						value: 6
					}
				],
				operationalstatusList: [{
					label: this.$t('vehicleInfo.caroperate'), //运营
					value: 1
				}, {
					label: this.$t('vehicleInfo.维修'), //维修
					value: 2
				}, {
					label: this.$t('vehicleInfo.停运'), //停驶
					value: 0
				}],
				businessAreaList: [{
					label: this.$t('vehicleInfo.other'),
					// value: "1"
					value: this.$t('vehicleInfo.other')

				}, {
					label: this.$t('vehicleInfo.withinthecounty'),
					// value: "2",
					value: this.$t('vehicleInfo.withinthecounty')
				}, {
					label: this.$t('vehicleInfo.intercounty'),
					// value: "3",
					value: this.$t('vehicleInfo.intercounty')
				}, {
					label: this.$t('vehicleInfo.intercity'),
					// value: "4",
					value: this.$t('vehicleInfo.intercity')
				}, {
					label: this.$t('vehicleInfo.interprovincial'),
					// value: "5",
					value: this.$t('vehicleInfo.interprovincial')
				}, {
					label: this.$t('vehicleInfo.international'),
					// value: "6",
					value: this.$t('vehicleInfo.international')
				}, ],
				industryList: [{
						label: this.$t('vehicleInfo.roadpatransportation'),
						value: "1"
					},
					{
						label: this.$t('vehicleInfo.scheduledbustransport'),
						value: "2"
					},
					{
						label: this.$t('vehicleInfo.charteredpatransportation'),
						value: "3"
					},
					{
						label: this.$t('vehicleInfo.itinerarytourism'),
						value: "4"
					},
					{
						label: this.$t('vehicleInfo.Noitinerarytourism'),
						value: "5"
					},
					{
						label: this.$t('vehicleInfo.roadtransportationdangerous'),
						value: "6"
					},
					{
						label: this.$t('vehicleInfo.opertransportationdangerous'),
						value: "7"
					}, {
						label: this.$t('vehicleInfo.Nonopertransportationdangerous'),
						value: "8"
					},
				],
				labelPosition: 'right',
				// modifyInfo: {
				// 	manufactureid: '',
				// 	vin: '',
				// 	modellevel: '',
				// 	carno: '',
				// 	province: '',
				// 	industry: '',
				// 	buydate: '',
				// 	vehicleownerinfo: '',
				// 	roadTransCerNo: '',
				// 	businessArea: '',
				// 	operationalstatus: '',
				// 	electricityprice: '',
				// 	deviceNo: '',
				// 	vehicleModel: '',
				// 	vehicleselfNo: '',
				// 	vehicleColor: '',
				// 	city: '',
				// 	deviceType: 'KL988',
				// 	usedate: '',
				// 	defaultDriver: '',
				// 	businesslicenseNo: '',
				// 	linetype: '',
				// 	oilprice: '',
				// 	gasprice: ''
				// }

			}
		},
		mounted() {
			this.LanguageId = language(this.$store.getters.locale);
			//查省份
			// this.queycity();
			// this.$api.queryProvince({

			// }).then((res) => {
			// 	if (res.data.length > 0) {
			// 		console.log(res)

			// 	}
			// });
			this.timeLineHeight = document.documentElement.clientHeight - 210;
			window.onresize = () => {
				this.timeLineHeight = document.documentElement.clientHeight - 210;
			};
			if (this.modifyInfo.buydate && this.modifyInfo.buydate.includes(' ')) {
				// 截取"YYYY-MM-DD"部分，适配date-picker的type="date"
				this.modifyInfo.buydate = this.modifyInfo.buydate.split(' ')[0];
			}

		},
		created() {
			//待改，以后台返回数据为准
			// this.modifyInfo.linetype = this.linetypeList[0].value;
			// this.modifyInfo.vehicleColor = this.vehicleColorList[4].value;
			// this.modifyInfo.industry = this.industryList[0].value;
			// this.modifyInfo.businessArea = this.businessAreaList[0].value;
			// this.modifyInfo.operationalstatus = this.operationalstatusList[0].value;
		},
		methods: {
			queycity() {
				this.cityList = [];
				this.$api.queryCity({
					provinceid: this.modifyInfo.province
				}).then((res) => {
					if (res.data.length > 0) {
						console.log(res)
						let newdata = res.data.map((val) => {
							return {
								label: val.cityname,
								value: val.cityid
							}
						})
						this.cityList = newdata;
						res.data.forEach((item) => {
							console.log(this.modifyInfo.city)
							if (this.modifyInfo.city == item.value) {
								this.modifyInfo.city == item.label;
							}
						})
					}
				})
			},
			seletekeyprovince(e) {
				console.log(e)
				//查市


			},
			// resetForm(formName) {
			// 	//待改，有些固定不能改的不能重置
			// // this.modifyInfobj = this.$options.data().modifyInfobj;
			// // this.modifyInfobj.carno="";
			// },
			cancel() {
				this.$emit('canceldialog', false)
			},
			save() {
				this.$emit('newmodifyInfo', this.modifyInfo)
			},
			newadd() {

			},
			dialognewadd() {
				this.$emit('transmit', this.newdriver);

			},
			// seletekey(e, type) {
			// 	console.log(e)
			// 	console.log(type)
			// 	if (e) {
			// 		switch (type) {
			// 			case 'province':
			// 				Object.keys(this.proviceList).filter(item => {
			// 					if (this.proviceList[item] === e) {
			// 						this.cityList = this.pcaaData[item]
			// 					}
			// 				})
			// 				break
			// 			case 'city':
			// 				Object.keys(this.cityList).filter(item => {
			// 					if (this.cityList[item] === e) {
			// 						this.countyList = this.pcaaData[item]
			// 					}
			// 				})
			// 				break
			// 			case 'area':
			// 				break
			// 		}
			// 	}
			// },
		}
	}
</script>

<style lang="scss" scoped>
	.driver {
		::v-deep .el-input__inner {
			font-size: 12px;
			width: 182px;
		}
	}
</style>